---
nb:
  market_outlook:
    duration: Durasjonskurve
    forward_contracts: Terminkontrakter
    futures_prices_ytd: Futurespriser så langt i år
    heading: Markedsutsikter
    high: P95
    info_text: Excel filen inneholder alle prisområder ikke bare de valgte.
    lowerq: Nedre kvartil
    median: Median
    minimum: P5
    nasim: Ikke mulig å simulere priser i prisområdet for øyeblikket
    pfc: Fremtidspriskurve
    pfc_table: Fremtidspristabell
    simulations: Prissimuleringer
    spot_prices_ytd: Kraftpriser så langt i år
    upperq: Øvre kvartil
